module.exports = __webpack_public_path__ + "assets/images/animal_r.209a5116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/animal_r.png
// module id = 676
// module chunks = 1